import * as types from './meeting-tasks.types';
import * as constants from './meeting-tasks.constants';
import { IMeetingSimple } from '../../../resource/meeting-simple/meeting-simple.types';

export const storeMeetingTasks = (meetingTasks: types.IMeetingTasks): types.IStoreMeetingTasks => ({
  type: constants.STORE_MEETING_TASKS,
  payload: meetingTasks,
});

export const clearMeetingTasks = (): types.IClearMeetingTasks => ({
  type: constants.CLEAR_MEETING_TASKS,
});

export const getMeetingTasks = (meetingId: IMeetingSimple['id']): types.IGetMeetingTasks => ({
  type: constants.GET_MEETING_TASKS,
  payload: meetingId,
});
